import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a16305b1e93da00146d2462_1788962573526_a7e1f915/kapramedical/src/app/facilities/FacilitiesPageClient.tsx");
